import { alpha, Box, useTheme } from '@mui/material';
import {
  FileExtensionSize,
  fileExtensionSizeMap,
  getFileExtensionFontSize,
  getFileExtensionRadius,
  resolveFileExtension,
} from './fileExtension.utils';

export type FileExtensionProps = {
  document: string;
  size?: FileExtensionSize;
  fontSize?: number;
  className?: string;
};

const FileExtension = ({ document, size = 'middle', fontSize, className }: FileExtensionProps) => {
  const theme = useTheme();
  const { extension, color } = resolveFileExtension(document);

  const numericSize = fileExtensionSizeMap[size];
  const computedFontSize = getFileExtensionFontSize(numericSize, extension.length, fontSize);
  const computedRadius = getFileExtensionRadius(numericSize);

  return (
    <Box
      className={className}
      data-testid='file-extension'
      title={extension}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxSizing: 'border-box',
        overflow: 'hidden',
        width: `${numericSize}px`,
        height: `${numericSize}px`,
        color: '#ffffff',
        textTransform: 'uppercase',
        borderRadius: `${computedRadius}px`,
        fontWeight: 700,
        fontSize: `${computedFontSize}px`,
        minWidth: `${numericSize}px`,
        lineHeight: 1,
        padding: 0,
        background: color ?? alpha(theme.palette.primary.darker, 0.8),
      }}
    >
      {extension}
    </Box>
  );
};

export default FileExtension;
